import { render } from "./ImprimirPickingAgrupado.vue?vue&type=template&id=a60fb020&scoped=true"
import script from "./ImprimirPickingAgrupado.vue?vue&type=script&lang=js"
export * from "./ImprimirPickingAgrupado.vue?vue&type=script&lang=js"

import "./ImprimirPickingAgrupado.vue?vue&type=style&index=0&id=a60fb020&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a60fb020"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
